import { useState, useEffect, useRef } from "react";

export default function AnimatedPrice({ value, duration = 500, prefix = "$",priceColor }) {
  const [displayed, setDisplayed] = useState(value);
  const prevValue = useRef(value);
  const animationRef = useRef();

  useEffect(() => {
    const startPrice = prevValue.current;
    const endPrice = value;
    const startTime = performance.now();
    const diff = endPrice - startPrice;

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const currentPrice = startPrice + diff * easeProgress;

      setDisplayed(currentPrice);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        prevValue.current = endPrice; 
      }
    }

    cancelAnimationFrame(animationRef.current);
    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, [value, duration]);

  return (
    <span className={`${priceColor} text-xl font-extrabold`}>
      {prefix}
      {displayed?.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </span>
  );
}
